module.exports = __webpack_public_path__ + "img/chevy-used.d0ca6576.png";